import { useEffect, useState } from "react";
import TaskCard from "../../../../components/TaskCard/TaskCard";
import style from "./EmployeeTasks.module.css";
import { Link, useParams } from "react-router";
import EmployeeNavBar from "../../Navbar/EmployeeNavbar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";
import TaskCardLoader from "../../../../components/LoadingComponents/TaskCardLoader/TaskCardLoader";

export default function EmployeeAllTasks() {
    const [tasks, setTasks] = useState([]);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true)
    const { employeeId } = useParams();
    const token = localStorage.getItem("token");

    const apiurl = process.env.REACT_APP_SERVER_URL;
    const tasksPerPage = 6;


    useEffect(() => {
        if (!apiurl) {
            setError("Api is not working");
            return;
        }

        fetch(`${apiurl}/employee/${employeeId}/tasks`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setLoading(false);
                setTasks(data.tasks);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(true);
            });
    }, [apiurl, employeeId, token]);

    // Pagination
    const indexOfLastTask = currentPage * tasksPerPage;
    const indexOfFirstTask = indexOfLastTask - tasksPerPage;
    const currentTasks = tasks.slice(indexOfFirstTask, indexOfLastTask);
    const totalPages = Math.ceil(tasks.length / tasksPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    return (
        <>
            <div className="container pt-lg-2">
                <div className={style.taskPage}>
                    <EmployeeNavBar />

                    {error && <p className="text-danger">{error}</p>}
                    <div>

                        <div className="row mb-2 ps-lg-3">
                            <div className="col-8 col-lg-6 ">
                                <BreadCrumb
                                    link={`/employee-dashboard/${employeeId}`}
                                    name="Dashboard"
                                    icon={true}
                                />
                                <BreadCrumb
                                    link={`/employee-dashboard/${employeeId}/all-tasks`}
                                    name="All Tasks"
                                    icon={false}
                                />
                            </div>

                            <div className="d-none  col-lg-4"></div>
                            <div className="col-4 col-lg-6 text-end pe-5 d-none d-lg-block">
                                <p className={style.breadcrumb}>
                                    Tasks: <b>{tasks.length}</b>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Grid layout */}
                    <div className="row g-4 ps-3 pe-3">

                        {loading ?
                            <>
                                {Array.from({ length: 6 }).map((_, idx) => {
                                    return (
                                        <>
                                            <div className="col-lg-6">
                                                <TaskCardLoader />
                                            </div>
                                        </>
                                    )
                                })}
                            </>
                            :
                            <>
                                {currentTasks.map((task, index) => (
                                    <div className="col-lg-6" key={index}>
                                        <Link
                                            to={`/employee-dashboard/${employeeId}/all-tasks/${task._id}`}
                                            style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                            <TaskCard
                                                title={task.title}
                                                assignedBy={task.assignedBy}
                                                status={task.status}
                                                finishingDate={task.finishingDate}
                                                finishingTime={task.finishingTime}
                                                priority={task.priority}
                                                preferences={task.preferences}
                                                assignedFor={task.employeeId.join(", ")}
                                            />
                                        </Link>
                                    </div>
                                ))}
                            </>
                        }

                    </div>
                </div>
            </div >

            {/* Pagination */}
            <div className="row mt-4 mb-4">
                <div className="col-12 text-center">
                    <button
                        style={{ border: "none" }}
                        className="btn mx-2"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                    >
                        <b>{"<<"}</b>
                    </button>
                    <span className="mx-2">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        style={{ border: "none" }}
                        className="btn mx-2"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                    >
                        <b>{">>"}</b>
                    </button>
                </div>
            </div>
        </>
    );
}
